import _ from 'underscore'

// Returns the list of controls for a given poll type
// and the user's access level
const SETS = {
  all: [
    'ToggleVisualSettings',
    'ChartNavigationContainer',
    'ToggleFTPChart',
    'ToggleClickRegions',
    'ToggleMCPChart',
    'Correctness',
    'Lock',
    'Archive',
    'Activate',
    'Fullscreen',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ToggleSurveyChart',
    'LockSurveyPolls',
    'ArchiveSurveyPolls',
    'ArchiveCompetitionResponses'
  ],
  limited: [
    'ToggleVisualSettings',
    'ToggleFTPChart',
    'Correctness',
    'ToggleMCPChart',
    'ToggleClickRegions',
    'Fullscreen',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ToggleSurveyChart'
  ],
  editor: [
    'ToggleVisualSettings',
    'ChartNavigationContainer',
    'ToggleFTPChart',
    'ToggleMCPChart',
    'ToggleClickRegions',
    'Correctness',
    'Lock',
    'Archive',
    'Activate',
    'Fullscreen',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ToggleSurveyChart',
    'LockSurveyPolls',
    'ArchiveSurveyPolls',
    'ArchiveCompetitionResponses'
  ],
  presentation: [
    'ToggleVisualSettings',
    'ToggleFTPChart',
    'ToggleMCPChart',
    'ToggleClickRegions',
    'Correctness',
    'Lock',
    'Archive',
    'Activate',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ToggleSurveyChart',
    'LockSurveyPolls',
    'ArchiveSurveyPolls',
    'ArchiveCompetitionResponses'
  ],
  fullscreen: ['ChartNavigationContainer', 'Fullscreen'],
  agave: [
    'ToggleVisualSettings',
    'ToggleFTPChart',
    'ToggleMCPChart',
    'ToggleClickRegions',
    'Correctness',
    'Lock',
    'Archive',
    'Activate',
    'ToggleClickMarkers',
    'EditPoll',
    'ToggleRecent',
    'ArchiveCompetitionResponses'
  ],
  office: [
    'ToggleVisualSettings',
    'ToggleFTPChart',
    'ToggleMCPChart',
    'ToggleClickRegions',
    'Correctness',
    'Lock',
    'Archive',
    'Activate',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ToggleSurveyChart',
    'LockSurveyPolls',
    'ArchiveSurveyPolls',
    'ArchiveCompetitionResponses'
  ],
  webpresenter: [
    'ToggleVisualSettings',
    'ToggleFTPChart',
    'ToggleMCPChart',
    'ToggleClickRegions',
    'Correctness',
    'Lock',
    'Archive',
    'Activate',
    'Fullscreen',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ToggleSurveyChart',
    'LockSurveyPolls',
    'ArchiveSurveyPolls',
    'ArchiveCompetitionResponses'
  ],
  tablet: [
    'ToggleFTPChart',
    'ToggleMCPChart',
    'ToggleSurveyChart',
    'ToggleClickRegions',
    'Correctness',
    'Lock',
    'LockSurveyPolls',
    'Archive',
    'ArchiveSurveyPolls',
    'Activate',
    'Fullscreen',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ChartNavigationContainer',
    'ArchiveCompetitionResponses'
  ],
  configurator: [
    'ToggleVisualSettings',
    'ToggleFTPChart',
    'ToggleClickRegions',
    'ToggleMCPChart',
    'Correctness',
    'ToggleClickMarkers',
    'ToggleRecent',
    'ToggleSurveyChart'
  ],
  onboarding: [
    'Activate'
  ],
  embed: [],
  none: []
}

const SETS_SHOWN_BY_DEFAULT = ['editor', 'office', 'webpresenter', 'onboarding']

const TYPES = {
  competition: [
    'ArchiveCompetitionResponses'
  ],

  leaderboard: ['ChartNavigationContainer'],

  multiple_choice_poll: [
    'ToggleVisualSettings',
    'Activate',
    'ToggleMCPChart',
    'Correctness',
    'Lock',
    'Archive',
    'EditPoll',
    'Fullscreen',
    'ChartNavigationContainer'
  ],
  free_text_poll: [
    'ToggleVisualSettings',
    'Activate',
    'ToggleFTPChart',
    'Lock',
    'Archive',
    'EditPoll',
    'Fullscreen',
    'ChartNavigationContainer'
  ],
  discourse: [
    'ToggleVisualSettings',
    'Activate',
    'ToggleRecent',
    'Lock',
    'Archive',
    'EditPoll',
    'Fullscreen',
    'ChartNavigationContainer'
  ],
  clickable_image: [
    'ToggleVisualSettings',
    'Activate',
    'ToggleClickMarkers',
    'ToggleClickRegions',
    'Lock',
    'Archive',
    'EditPoll',
    'Fullscreen',
    'ChartNavigationContainer'
  ],
  ranking_poll: [
    'ToggleVisualSettings',
    'Activate',
    'ToggleMCPChart',
    'Lock',
    'Archive',
    'EditPoll',
    'Fullscreen',
    'ChartNavigationContainer'
  ],
  survey: [
    'Activate',
    'ToggleSurveyChart',
    'LockSurveyPolls',
    'ArchiveSurveyPolls',
    'Fullscreen',
    'ChartNavigationContainer'
  ]
}

const OWNER_REQUIRED = [
  'Archive',
  'Correctness',
  'Lock',
  'Activate',
  'ChartNavigationContainer',
  'LockSurveyPolls',
  'ArchiveSurveyPolls'
]

export function hasAccessTo (type, set, isOwner) {
  const controlType = TYPES[type] || []
  const controlSet = SETS[set]

  // _.intersection returns matches in the order
  // of the first array passed in. Important to
  // get control order correct
  let controls = _.intersection(controlType, controlSet)
  if (!isOwner) {
    controls = _.difference(controls, OWNER_REQUIRED)
  }

  return controls
}

export function displaySetByDefault (set) {
  return _.contains(SETS_SHOWN_BY_DEFAULT, set)
}
